import { q, sanityImage } from 'groqd'

import { imageAsset } from '@/cms/helperTypes'

export const categoriesQuery = q('*')
  .filter('_type == "blogCategory"')
  .grab({
    _id: q.string(),
    slug: ['slug[$lang].current', q.string()],
    title: ['title[$lang]', q.string()],
    position: q.number(),
  })
  .order('position asc')

export const postsQuery = q('*')
  .filter(
    `
  _type == "blogPost" &&
  $lang in availableLanguages &&
  $market in availableMarkets &&
  enabledInProduction == true &&
  publicationType == "blogPost" &&
  (publishAfter < now() || !defined(publishAfter)) &&
  ($category in categories[]->slug[$lang].current || !defined($category))
  `
  )
  .grab({
    _id: q.string(),
    slug: ['slug[$lang].current', q.string()],
    heading: ['heading[$lang]', q.string()],
    description: ['description[$lang]', q.string()],
    heroImage: q('heroImage')
      .grab({
        alt: ['alt[$lang]', q.string().nullable()],
        image: sanityImage('localeHeroImage[$lang]', {
          withHotspot: true,
          withAsset: ['base', 'dimensions', 'lqip'],
        }).nullable(),
      })
      .nullable(),
    author: q('author')
      .deref()
      .grab({
        firstName: q.string(),
        image: q('image').grab({
          _type: q.literal('image'),
          asset: q('asset').deref().grab(imageAsset).nullable(),
        }),
      }),
    publishAfter: q.date().nullable(),
    publishDate: q.date().nullable(),
    readingTime: q.number(),
    categories: q('categories')
      .filter()
      .deref()
      .grab({
        slug: ['slug[$lang].current', q.string()],
      }),
  })
  .order('publishDate desc')
